import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ui-expander-content',
  templateUrl: './expander-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './expander-content.component.scss',
})
export class ExpanderContentComponent {
  public expanded: InputSignal<boolean> = input.required();
}
